//封装数据懒加载函数
// hooks 封装逻辑，提供响应式数据。
import { useIntersectionObserver, useIntervalFn } from '@vueuse/core'
import { ref, onUnmounted } from 'vue'
import { ElMessage } from 'element-plus'
import dayjs from 'dayjs'
// 数据懒加载函数

export const useLazyData = (target, apiFn) => {
  // 需要
  // 1. 被观察的对象
  // 2. 不同的API函数
  //const target = ref(null)
  const result = ref([])
  //stop停止观察
  try {
    const { stop } = useIntersectionObserver(
      //要观察的目标对象（dom对象）
      target,
      ([{ isIntersecting }], observerElement) => {
        //isIntersecting 是否进入可视/观察区域
        if (isIntersecting) {
          stop()
          // 调用API获取数据

          try {
            apiFn().then(data => {
              result.value = data.map((item) => {
                return {
                  chID: item.chID,
                  maID: item.maID,
                  coID: item.coID,
                  clID: item.clID,
                  leName: item.leName,
                  coverImg: item.coverImg,
                  grade: item.grade.find((ele) => ele._id == item.gradeID),
                  id: item._id
                };
              });
            })
          } catch (error) {
            //ElMessage.error(error.message);
            console.log(error.message);
          }
        }
      }, {
      threshold: 0
    }
    )
    // 返回--->数据（dom,后台数据）
    return { result }
  } catch (error) {
    //ElMessage.error(error.message);
    console.log(error.message);
  }
}

//news新闻页面懒加载
export const useLazyNews = (target, apiFn) => {
  // 需要
  // 1. 被观察的对象
  // 2. 不同的API函数
  const notice = ref([]);
  const policy = ref([]);
  //stop停止观察
  try {
    const { stop } = useIntersectionObserver(
      //要观察的目标对象（dom对象）
      target,
      ([{ isIntersecting }], observerElement) => {
        //isIntersecting 是否进入可视/观察区域
        if (isIntersecting) {
          stop()
          // 调用API获取数据

          try {
            apiFn().then(data => {
              notice.value = data.notice;
              policy.value = data.policy;
            })
          } catch (error) {
            //ElMessage.error(error.message);
            console.log(error.message);
          }
        }
      }, {
      threshold: 0
    }
    )
    // 返回--->数据（dom,后台数据）
    return { notice, policy }
  } catch (error) {
    //ElMessage.error(error.message);
    console.log(error.message);
  }
}

//news新闻页面题库推荐懒加载

export const useLazyNewsTests = (target, apiFn) => {
  // 需要
  // 1. 被观察的对象
  // 2. 不同的API函数
  //const target = ref(null)
  const testList = ref([])
  //stop停止观察
  try {
    const { stop } = useIntersectionObserver(
      //要观察的目标对象（dom对象）
      target,
      ([{ isIntersecting }], observerElement) => {
        //isIntersecting 是否进入可视/观察区域
        if (isIntersecting) {
          stop()
          // 调用API获取数据

          try {
            apiFn().then(data => {

              try {
                testList.value = data.map((item) => {
                  return {
                    chID: item.chID,
                    maID: item.maID,
                    coID: item.coID,
                    clID: item.clID,
                    grade: item.grade.find((ele) => ele._id == item.gradeID),
                    testsName: item.testsName,
                    id: item._id,
                    testsCoverImg: item.testsCoverImg,
                  };
                });
              } catch (error) {
                console.log(error);
              }
            })
          } catch (error) {
            //ElMessage.error(error.message);
            console.log(error.message);
          }
        }
      }, {
      threshold: 0
    }
    )
    // 返回--->数据（dom,后台数据）
    return { testList }
  } catch (error) {
    // ElMessage.error(error.message);
    console.log(error.message);
  }
}

//news新闻页面题库推荐懒加载

export const useLazyNewsBanner = (target, apiFn) => {
  // 需要
  // 1. 被观察的对象
  // 2. 不同的API函数
  //const target = ref(null)
  const bannerList = ref([])
  //stop停止观察
  try {
    const { stop } = useIntersectionObserver(
      //要观察的目标对象（dom对象）
      target,
      ([{ isIntersecting }], observerElement) => {
        //isIntersecting 是否进入可视/观察区域
        if (isIntersecting) {
          stop()
          // 调用API获取数据

          try {
            apiFn().then(data => {

              bannerList.value = data.map((item) => {
                return {
                  chID: item.chID,
                  maID: item.maID,
                  coID: item.coID,
                  clID: item.clID,
                  id: item._id,
                  bannerImg: item.bannerImg,
                  bannerName: item.bannerName,
                  bannerUrl: item.bannerUrl,
                  bannerDesc: item.Desc
                };
              });

            })
          } catch (error) {
            //ElMessage.error(error.message);
            console.log(error.message);
          }
        }
      }, {
      threshold: 0
    }
    )
    // 返回--->数据（dom,后台数据）
    return { bannerList }
  } catch (error) {
    // ElMessage.error(error.message);
    console.log(error.message);
  }
}

//tests题库懒加载
export const useLazyTests = (target, apiFn) => {
  // 需要
  // 1. 被观察的对象
  // 2. 不同的API函数
  //const target = ref(null)
  const result = ref([])
  const resultCount = ref(0)
  //stop停止观察
  try {
    const { stop } = useIntersectionObserver(
      //要观察的目标对象（dom对象）
      target,
      ([{ isIntersecting }], observerElement) => {
        //isIntersecting 是否进入可视/观察区域
        if (isIntersecting) {
          stop()
          // 调用API获取数据

          try {
            apiFn().then(data => {
              try {
                resultCount.value = data.resultLength[0].length
                result.value = data.result.map((item) => {
                  return {
                    chID: item.chID,
                    maID: item.maID,
                    coID: item.coID,
                    clID: item.clID,
                    grade: item.grade.find((ele) => ele._id == item.gradeID),
                    testsName: item.testsName,
                    id: item._id,
                    testsCoverImg: item.testsCoverImg,
                  };
                });
              } catch (error) {
                console.log(error.message);
              }
            })
          } catch (error) {
            //ElMessage.error(error.message);
            console.log(error.message);
          }
        }
      }, {
      threshold: 0
    }
    )
    // 返回--->数据（dom,后台数据）
    return { result, resultCount }
  } catch (error) {
    // ElMessage.error(error.message);
    console.log(error.message);
  }
}


/**
 * 支付倒计时函数
 */
export const usePayTime = () => {
  // 倒计时逻辑
  const time = ref(0)
  const timeText = ref('')
  const { pause, resume } = useIntervalFn(() => {
    time.value--
    timeText.value = dayjs.unix(time.value).format('mm分ss秒')
    if (time.value <= 0) {
      console.log(time.value);
      pause()
    }
  }, 1000, false)
  onUnmounted(() => {
    pause()
  })

  // 开启定时器 countdown 倒计时时间
  const start = (countdown) => {

    time.value = countdown
    timeText.value = dayjs.unix(time.value).format('mm分ss秒')
    resume()
  }

  return {
    start,
    timeText
  }
}

//home-lesson侧边栏banner懒加载

export const useLazySideImg = (target, apiFn) => {
  // 需要
  // 1. 被观察的对象
  // 2. 不同的API函数
  const result = ref([]);

  //stop停止观察
  try {
    const { stop } = useIntersectionObserver(
      //要观察的目标对象（dom对象）
      target,
      ([{ isIntersecting }], observerElement) => {
        //isIntersecting 是否进入可视/观察区域
        if (isIntersecting) {
          stop()
          // 调用API获取数据

          try {
            apiFn().then(data => {
              result.value = data;
            })
          } catch (error) {
            //ElMessage.error(error.message);
            console.log(error.message);
          }
        }
      }, {
      threshold: 0
    }
    )
    // 返回--->数据（dom,后台数据）
    return { result }
  } catch (error) {
    //ElMessage.error(error.message);
    console.log(error.message);
  }
}